import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSplit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2236_26974)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.26115 11.4825C3.26115 11.0714 2.95535 10.7392 2.57856 10.7392H0.765598C0.388808 10.7392 0.0830078 11.0714 0.0830078 11.4825C0.0830078 11.8937 0.388808 12.2259 0.765598 12.2259H2.57856C2.95535 12.2259 3.26115 11.8937 3.26115 11.4825Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.9294 10.7419C4.55261 10.7419 4.24681 11.0741 4.24681 11.4853C4.24681 11.8964 4.55261 12.2286 4.9294 12.2286H6.74235C7.11914 12.2286 7.42494 11.8964 7.42494 11.4853C7.42494 11.0741 7.11914 10.7419 6.74235 10.7419H4.9294Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9062 10.7419H9.09319C8.7164 10.7419 8.4106 11.0741 8.4106 11.4853C8.4106 11.8964 8.7164 12.2286 9.09319 12.2286H10.9062C11.2829 12.2286 11.5887 11.8964 11.5887 11.4853C11.5887 11.0741 11.2829 10.7419 10.9062 10.7419Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.07 10.7419H13.257C12.8802 10.7419 12.5744 11.0741 12.5744 11.4853C12.5744 11.8964 12.8802 12.2286 13.257 12.2286H15.07C15.4467 12.2286 15.7525 11.8964 15.7525 11.4853C15.7525 11.0741 15.4467 10.7419 15.07 10.7419Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.2337 10.7419H17.4208C17.044 10.7419 16.7382 11.0741 16.7382 11.4853C16.7382 11.8964 17.044 12.2286 17.4208 12.2286H19.2337C19.6105 12.2286 19.9163 11.8964 19.9163 11.4853C19.9163 11.0741 19.6105 10.7419 19.2337 10.7419Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6399 13.3314H16.2604C15.9655 13.3314 15.7252 13.5656 15.717 13.8596V17.7044H4.26865V13.8596H4.26046C4.25227 13.5656 4.012 13.3314 3.71712 13.3314H3.35944C3.06456 13.3314 2.82429 13.5656 2.8161 13.8596V18.4341C2.8161 18.8371 3.14374 19.1666 3.54237 19.1666H16.457C16.8583 19.1666 17.1833 18.8371 17.1833 18.4341V13.8596C17.1751 13.5656 16.9348 13.3314 16.6399 13.3314Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.3649 9.64458H3.72258C4.01746 9.64458 4.25773 9.41041 4.26592 9.11633V2.29545H10.7614V6.54046C10.7614 6.94345 11.0891 7.27293 11.4877 7.27293H15.7089V9.12178C15.717 9.41585 15.9573 9.65002 16.2522 9.65002H16.6317C16.9266 9.65002 17.1669 9.41585 17.1751 9.12178V6.12658C17.1751 5.92781 17.0986 5.74538 16.9648 5.60923L12.4406 1.04564C12.3041 0.909493 12.1212 0.833252 11.9246 0.833252H3.53964C3.13828 0.833252 2.81337 1.16272 2.81337 1.56571V9.11633H2.82156C2.82975 9.41041 3.07002 9.64458 3.3649 9.64458ZM12.2358 2.89722L15.1327 5.81073H12.2358V2.89722Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2236_26974",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgIconSplit;
